export default __webpack_public_path__ + "af9afdc10c93e4118e90aa90435f9baa.woff2";